<template>
    <div :class="{wrap:wrap}">
        <div class="radio-select" :data-val="value">
            <div class="top">
                <span class="required" v-if="required">*</span>
                <div class="title" v-html="title"></div>
            </div>
            <template v-for="item in options">
                <template v-if="isDetails">
                    <SelectOption :data-is-verdict="item.isVerdict" @click.native="selectOption(item.val)" class="option"  :desc="item.desc" :key="item.val" :active="value === item.val" v-if="isDetails && value == item.val" :border="false"></SelectOption>
                </template>
                <template v-else>
                    <SelectOption :data-is-verdict="item.isVerdict" @click.native="selectOption(item.val)" class="option"  :desc="item.desc" :key="item.val" :active="value === item.val"  :border="false"></SelectOption>
                </template>
                <div class="child-option">
                    <InputOption :isDetails="isDetails" v-if="item.input && value == item.val"  v-bind="item.input.props" v-model="item.input.value"></InputOption>
                </div>
            </template>

        </div>
    </div>
</template>
<script>
    import SelectOption from './Private/SelectOption.vue'
    import InputOption from '@/components/NursingEvaluation/DoTopic/Private/InputOption.vue'//不对外开放

    export default {
        name: 'RadioSelectAndInput',
        props: {
            value:Number,
            title:String,
            required:Boolean,
            options: {
                type: Array,
                default:function () {
                    return []
                }
            },
            wrap:{
                type: Boolean,
                default:false
            },
            isDetails:{
                type:Boolean,
                default:false
            }
        },
        methods:{
            selectOption(val){
                if(this.isDetails){return;}

                if(val == this.value){
                    this.$emit('input',null);
                    return
                }
                this.$emit('input',val)
            }
        },
        components:{SelectOption,InputOption}
    }
</script>
<style lang="scss" scoped>
    .wrap{
        padding: 0 16px;
    }
    .radio-select{
        border: 1px solid #D6D3D3;
        padding: 16px;
        .top{
            display: flex;
            align-items: center;
            .required{
                color: #F84025;
                margin-right: 6px;
            }
            .title{
                color: #26292F;
                position: relative;
                font-size: 16px;
                display: flex;
                align-items: center;
                &:before{
                    content: '';
                    display: block;
                    margin-right: 6px;
                    width: 12px;
                    height: 12px;
                    background: #FFA307;
                }
            }
        }
        .option{
            margin-top: 16px;
        }
        .child-option{
            margin-left: 40px;
        }
    }

</style>
